export default __webpack_public_path__ + "static/media/visibilityIcon.d42e2dff.svg";